export const Validations={
 hasWhiteSpace(s){
        return /\s/g.test(s);
      }
}